import { Box } from '@mui/material';

export const NURSE = () => {
  return <Box sx={{ flex: 1 }}></Box>;
};
